import { Link } from "react-router-dom";
import "./index.css";

const courses = [
  "Fullstack Developer Course",
  "MERN Stack Developer Course",
  "Data Science Course",
  "Artificial Intelligence & Machine Learning Course",
  "Cyber Security Course",
  "Augmented Reality & Virtual Reality (AR/VR) Courses",
  "Block Chain Course",
  "PowerBI Course",
  "Amazon Web Services(AWS) Course",
  "ServiceNow Courses",
  "SAP Courses",
];

const TrendingCourses = () => {
  return (
    <div className="p-3 text-center">
      <h2 className="text-center text-3xl font-bold mb-6 text-gradient">
        Trending Courses
      </h2>
      <div className="flex flex-wrap justify-center gap-4 px-6">
        {courses.map((course, index) => (
          <span key={index}>{course} Hyderabad | </span>
        ))}
      </div>
    </div>
  );
};

const Footer = () => {
  const phoneNumber = "+919100884508"; // Replace with your full number (no +)
  const message = "Hello, I'm interested to know more about IBIX courses!";

  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-section about">
          <h2>IBIX Qodify</h2>
          <p>Technologies</p>
          <p className="mb-3">
            Transforming careers through industry-leading tech education. Join
            thousands of successful professionals who achieved their dream jobs
            with us.
          </p>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/Iqteche"
              target="_blank"
              rel="noreferrer"
              className="facebook"
            >
              <i className="fab fa-facebook"></i>
            </a>

            <a
              href="https://x.com/IbixQodify"
              target="_blank"
              rel="noreferrer"
              className="x-twitter"
            >
              <i className="fab fa-x-twitter"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/ibix-qodify-technologies/?viewAsMember=true"
              target="_blank"
              rel="noreferrer"
              className="linkedin"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://www.instagram.com/ibix_qodify64/"
              target="_blank"
              rel="noreferrer"
              className="instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>

            <a
              href="https://youtube.com/@ibixqodifytechnologies?feature=shared"
              target="_blank"
              rel="noreferrer"
              className="youtube"
            >
              <i className="fab fa-youtube"></i>
            </a>

            <i className="fab fa-whatsapp whatsapp" onClick={handleClick}></i>
          </div>
        </div>

        {/* <div className="footer-section courses">
          <h3>Popular Courses</h3>
          <ul>
            <li>Full Stack Development</li>
            <li>Data Science & AI</li>
            <li>Cloud Computing & DevOps</li>
            <li>Mobile App Development</li>
            <li>Cybersecurity</li>
            <li>Digital Marketing</li>
          </ul>
        </div> */}

        <div className="footer-section company">
          <h3>Company</h3>
          <ul>
            <li>
              <Link to="/about-us" className="company-Link">
                About Us
              </Link>
            </li>

            <li>
              <Link to="/careers" className="company-Link">
                Careers
              </Link>
            </li>
            <li>
              <Link to="/services" className="company-Link">
                Services
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section contact">
          <h3>Contact Us</h3>
          <p>
            <i className="fas fa-envelope"></i> info@ibixqt.in
          </p>
          <p>
            <i className="fas fa-phone"></i> 091008 84508
          </p>
          <p>
            <i className="fas fa-map-marker-alt"></i> 496, Izzathnagar,
            <br />
            Hyderabad, Kothaguda,
            <br /> Telangana 500084
          </p>
        </div>
      </div>

      <div className="states-section">
        <h5>Course Tracks</h5>
        <div className="d-flex align-items-center">
          <p>Andhra Pradesh</p>
          <p>Telangana</p>
          <p>Tamilnadu</p>
          <p>Kerala</p>
          <p>Karnataka</p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="payments">
          <span>Accepted Payment Methods:</span>
          <span className="badge visa bg-danger">VISA</span>
          <span className="badge master bg-success">MASTER</span>
          <span className="badge upi bg-primary">UPI</span>
          <span className="badge paytm">PAYTM</span>
        </div>

        <div className="policies">
          <Link to={"/terms-and-privacy"} className="footer-links">
            <span>Terms & Conditions - Privacy Policy</span>
          </Link>

          <Link to={"/terms-and-privacy"} className="footer-links">
            <span></span>
          </Link>
        </div>

        {/* <div className="certifications">
          <span>Certifications:</span>
          <span className="badge">ISO 9001:2015</span>
          <span className="badge">NASSCOM</span>
          <span className="badge">AICTE</span>
        </div> */}
      </div>

      {TrendingCourses()}

      <div className="footer-note">
        <p>© 2026 IBIX Qodify Technologies. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
